/**
 * Hero variants that are their own component. HeroSection.tsx renders the six
 * founding variants itself and consults this table first; a listed variant
 * takes over the whole section. Adding a hero design = one file + one line
 * here, plus its value in KNOB_VALUES.hero_variant (registry package).
 *
 * Entries should be lazy (`lazy(() => import('./AppShowcaseHero'))`): a hero
 * variant can be heavy (device frames, a starfield) and only the tenants on
 * it should download it. HeroSection wraps the render in Suspense.
 */
import type { ComponentType, LazyExoticComponent } from 'react';
import type { HeroVariant } from '@/looks';

export interface HeroVariantProps {
  section: any;
}

export type HeroVariantComponent =
  | ComponentType<HeroVariantProps>
  | LazyExoticComponent<ComponentType<HeroVariantProps>>;

export const HERO_VARIANT_COMPONENTS: Readonly<Partial<Record<HeroVariant, HeroVariantComponent>>> = {};
